import { CardHistoryEntry, CardRecord, SrsFeedback } from '../db/indexedDb';
import { computeNextReview, type SkillConfig, type SrsResult } from './scheduler';

export interface ReviewOutcome {
  card: CardRecord;
  historyEntry: CardHistoryEntry;
  schedule: SrsResult;
}

export interface ReviewOptions {
  notes?: string;
  skillConfig?: Partial<SkillConfig>;
  now?: number;
  answerMeta?: Record<string, unknown>;
}

export function applyReview(card: CardRecord, feedback: SrsFeedback, options: ReviewOptions = {}): ReviewOutcome {
  const now = options.now ?? Date.now();
  const schedule = computeNextReview(card, feedback, now, options.skillConfig);

  const historyEntry: CardHistoryEntry = {
    ts: now,
    rating: feedback,
    interval: schedule.interval,
    nextReviewDate: schedule.nextReviewDate,
    ease: schedule.ease,
    mode: schedule.mode,
    answerMeta: options.answerMeta,
    notes: options.notes,
  };

  const updatedCard: CardRecord = {
    ...card,
    interval: schedule.interval,
    ease: schedule.ease,
    consecutiveGood: schedule.consecutiveGood,
    nextReviewDate: schedule.nextReviewDate,
    mode: schedule.mode,
    isRelearn: schedule.isRelearn,
    relearnBucket: schedule.relearnBucket,
    priority: schedule.priority,
    history: [...card.history, historyEntry],
    updatedAt: now,
  };

  return { card: updatedCard, historyEntry, schedule };
}
